import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface DeviceAccessProtectedRouteProps {
  children: React.ReactNode;
  required: 'pro' | 'lite' | 'mono' | 'any-software';
}

const getDeviceAccess = (user: any) => ({
  pro: user?.deviceAccess?.pro ?? true,
  lite: user?.deviceAccess?.lite ?? false,
  mono: user?.deviceAccess?.mono ?? false,
});

const DeviceAccessProtectedRoute: React.FC<DeviceAccessProtectedRouteProps> = ({ children, required }) => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'USER' && user.role !== 'STAFF_USER') {
    return <>{children}</>;
  }

  const access = getDeviceAccess(user);
  const allowed =
    required === 'any-software'
      ? access.pro || access.lite || access.mono
      : access[required];

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default DeviceAccessProtectedRoute;
